import React from 'react'
import { Box } from '@chakra-ui/react'

const Inventory = () => {
    return (
        <Box padding={5}>Placeholder page for Reports</Box>
    )
}

export default Inventory